interface Item {
  title: string
  content: Array<string>
}
interface AgreementData {
  introduce: string
  content: Array<Item>
}
export const data: AgreementData = {
  introduce: '本网站系中国医院协会病案专业委员会及北京雅丁信息技术有限公司（以下简称“公司”）合法拥有并运营的、标注名称为“中国病案百年博物馆”的公益性网站。当用户您阅读、并确认同意本协议或接受服务后，即表示您已充分阅读、理解并接受本协议的全部内容，本协议对您及本平台均具有法律约束力。',
  content: [
    {
      title: '一、服务内容',
      content: [
        '1、本网站主旨为纪念中国病案100年和《中国病案》杂志20年而创建，共含7个版块，即“中国病案100年视频、领导寄语、百年历程、病案老物件、百年名人堂、病案新风采、《中国病案》杂志20年”。',
        '2、从中国病案与最具代表性的《中国病案》杂志历史介绍，到全国各院的老物件展示，再到新一代病案人风貌，以网站形式为全国病案人提供一个了解病案历史，纪念病案领袖，向优秀病案人学习看齐的平台。同时，也为全国的病案人提供了一个分享本院老物件，记录本院历史和展示科室病案风采的窗口。从而，凝聚全国病案力量，推动中国病案蓬勃发展。'
      ]
    },
    {
      title: '二、推广使用',
      content: [
        '本网站鼓励第三方在获得作品相关权利人授权或同意后，复制、传播登载在本网站上的资料，使用时需注明“资料来源：中国病案百年博物馆（网址：mr100.yadingdata.com） ”。'
      ]
    },
    {
      title: "三、用户账号注册及使用规则",
      content: [
        '1、用户注册成功后，本网站将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。 ',
        '2、用户须对在本网站的注册信息的真实性、合法性、有效性承担全部责任，用户不得冒充他人（包括但不限于冒用他人姓名、名称、字号、头像等足以让人引起混淆的方式）开设账号；不得利用他人的名义发布任何信息；不得恶意使用注册帐户导致其他用户误认；否则本网站有权立即停止提供服务，收回其帐号并由用户独自承担由此而产生的一切法律责任。 ',
        '3、用户理解且确认，其在本网站注册账号的所有权及有关权益均归本公司所有，用户完成注册手续后仅享有该账号的使用权。您的账号仅限于您本人使用，未经本公司书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。如果本公司发现或者有合理理由认为使用者并非账号初始注册人，公司有权在未通知您的情况下，暂停或终止向该注册账号提供服务，并有权注销该账号，而无需向注册该账号的用户承担法律责任。 ',
        '4、用户承诺不得以任何方式利用本网站直接或间接从事违反中国法律、以及社会公德的行为，本网站有权对违反上述承诺的内容予以删除。 ',
        '5、用户不得利用本网站制作、上载、复制、发布、传播或者转载如下内容： ',
        '（1）反对宪法所确定的基本原则的；',
        '（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；',
        '（3）损害国家荣誉和利益的；',
        '（4）煽动民族仇恨、民族歧视，破坏民族团结的；',
        '（5）破坏国家宗教政策，宣扬邪教和封建迷信的；',
        '（6）散布谣言，扰乱社会秩序，破坏社会稳定的；',
        '（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；',
        '（8）侮辱或者诽谤他人，侵害他人合法权益的；',
        '（9）含有法律、行政法规禁止的其他内容的信息。',
        '6、本网站鼓励用户充分利用本网站平台自由地发布和共享自己的信息，用户对于其创作并在本网站上发布的合法内容（包括但不限于文字、图片、视频、音频等）依法享有著作权。用户不应通过本网站发布他人受知识产权法律等保护的内容，除非获得他人的合法授权。就用户发布的内容，若第三方向本网站投诉并提交初步证据，经本网站判断投诉属实的，本网站有权删除这些内容。如因用户发布的内容给本网站带来损失的，用户应当负责赔偿。',
        '7、 用户理解，本网站仅提供相关的服务，除此之外与相关服务有关的设备（如电脑、调制解调器及其他与接入互联网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费）均应由用户自行负担。 ',
        '8、用户理解，本网站提供的服务内容可能包括：文字、软件、声音、图片、视频、图表等。所有这些内容受著作权、商标和其它财产所有权法律的保护。用户只有在获得本网站或其他相关权利人的授权之后才能使用这些内容，不能擅自复制、再造这些内容、或创造与内容有关的派生产品。',
        '9、用户理解，如用户丢失帐号或遗忘密码，可遵照网站的申诉途径及时申诉请求找回帐号或密码。用户理解并认可，密码找回机制仅需要识别申诉单上所填资料与系统记录资料具有一致性，而无法识别申诉人是否系帐号真正有权使用者。网站特别提醒您应妥善保管您的帐号和密码。当用户使用完毕后，应安全退出。因用户保管不当等自身原因或其他不可抗因素导致遭受盗号或密码丢失，用户应自行承担相应责任。',
        '10、本网站有权对用户使用本网站的情况进行审查和监督，如用户在使用本网站时违反任何上述规定，本网站或其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张贴的内容、暂停或终止用户使用本网站的权利）以减轻用户不当行为造成的影响。',
      ]
    },
    {
      title: '四、用户承诺及授权',
      content: [
        '1、用户理解并承诺，用户在使用本网站及相关服务时发布上传的内容（包括但不限于文字、图片、视频、音频等各种形式的内容及其中包含的文字、音乐、声音、台词、视觉设计等所有组成部分）均由用户原创或已获合法授权（且含转授权）。您通过本网站上传、发布所产生内容的知识产权归属您或原始著作权人所有。 ',
        '2、用户知悉、理解并同意其通过本网站发布上传的内容（包括但不限文字，图片，视频，音频等各种形式的内容及其中包括的文字、音乐、声音、台词、视觉设计、对话等所有组成部分），授权本公司及其关联公司、控制公司可在全球范围内、免费、非独家、可转授权地使用，使用范围包括但不限于在当前或其他网站、应用程序、产品或终端设备等，您在此确认并同意，上述授予的权利包括在本网站及相关服务、公司和/或公司品牌有关的任何宣传、推广、广告、营销和/或研究中使用和以其他方式开发内容（全部或部分）的权利和许可。为避免疑义，您理解并同意，上述授予的权利包括使用、复制和展示您拥有或被许可使用并植入内容中的个人形象、肖像、姓名、商标、服务标志、品牌、名称、标识和公司标记（如有）以及任何其他品牌、营销或推广资产、物料、素材等的权利和许可。 ',
        '3、用户确认并同意授权本公司以公司名义或委托专业第三方对侵犯用户上传发布的享有知识产权的内容进行代维权，维权形式包括但不限于：监测侵权行为、发送维权函、提起诉讼或仲裁、调解、和解等，本公司有权对维权事宜做出决策并独立实施。 ',
        '4、用户承诺在实际使用本网站服务时，应当具备中华人民共和国法律规定的完全民事行为能力。若用户不具备完全民事行为能力，请用户务必在家长和其他法定监护人的同意及全程陪同下使用本网站服务。否则用户及用户的监护人应依照法律规定承担因此而导致的一切后果，在该等情形下，本网站有权注销用户的账号或停止向用户提供服务。',
        '5、在注册、使用和管理帐号时，用户应保证注册帐号时填写的身份信息的真实性，请用户在注册、管理帐号时使用真实、准确、合法、有效的相关身份证明材料及必要信息（包括用户的姓名及电子邮件地址、联系电话、联系地址等）。依照国家法律法规的规定，为使用“网站及相关服务的部分功能，用户需要填写真实的身份信息，请用户按照相关法律规定完成实名认证，并注意及时更新上述相关信息。若用户提交的材料或提供的信息不准确、不真实、不规范、不合法或者网站有理由怀疑为错误、不实或不合法的资料，则本网站有权拒绝为用户提供相关服务，用户可能无法使用本网站及相关服务或在使用过程中部分功能受到限制。'
      ]
    },
    {
      title: '五、知识产权',
      content: [
        '本公司在本网站及相关服务中提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、商标、标识、音频、视频、图表、版面设计、电子文档等）的知识产权属于本公司所有。同时本公司提供服务所依托的软件的著作权、专利权、商标及其他知识产权均归本公司所有。未经本公司许可，任何人不得擅自使用（包括但不限于通过任何程序或设备监视、复制、传播、展示、镜像、上载、下载本网站及相关服务中的内容）。'
      ]
    },
    {
      title: '六、免责声明',
      content: [
        '1、用户将照片、个人信息等资料上传到互联网上，有可能会被其他组织或个人复制、转载、擅改或做其它非法用途，用户必须充分意识此类风险的存在。用户明确同意其使用本网站服务所存在的风险（包括但不限于受到第三方侵权或对第三方造成侵权）完全由其自己承担；因其使用本网站服务而产生的一切后果也由其自己承担，公司对此不承担任何责任。',
        '2、公司不担保本网站服务一定能满足用户的要求，也不担保本网站服务不会中断，对本网站服务的及时性、安全性、准确性、真实性、完整性也都不作担保。',
        '3、对于因不可抗力或公司不能控制的原因造成的本网站服务中断或其它缺陷，公司不承担任何责任，但公司将尽力减少因此而给用户造成的损失和影响。',
        '4、根据有关法律法规，公司在此郑重提请用户注意，本网站作为信息存储空间及网络平台服务的提供者，任何经由本网站以上载、张发送电子邮件或任何其它方式传送的资讯、资料、文字、软件、音乐、音讯、照片、图形、视讯、信息或其它资料（以下简称“内容”），无论系公开还是私下传送，均由内容提供者承担责任。公司无法控制经由本网站传送之内容，因此不保证内容的正确性、完整性或品质。在任何情况下，公司均不为任何内容负责，包含但不限于任何内容之任何错误或遗漏，以及经由本网站服务功能或其它方式传送任何内容而衍生之任何损失或损害。但公司有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用本网站服务的全部或部分，保存有关记录，并向有关机关报告。',
        '5、公司作为本网络服务提供者，对非法转载，虚假发布、盗版行为的发生不具备充分的监控能力。公司对他人在网站上实施的此类侵权行为不承担法律责任，侵权的法律责任概由本人承担。'
      ]
    },
    {
      title: '七、违约责任',
      content: [
        '1、针对用户违反本协议或其他服务条款的行为，本公司有权独立判断并视情况采取预先警示、拒绝发布、立即停止传输信息、删除跟帖、短期禁止发言、限制账号部分或者全部功能直至永久关闭账号等措施。本公司有权公告处理结果，且有权根据实际情况决定是否恢复使用。对涉嫌违反法律法规、涉嫌违法犯罪的行为将保存有关记录，并依法向有关主管部门报告、配合有关主管部门调查。',
        '2、因用户违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，用户应当自行承担全部法律责任。因用户的违法或违约行为导致公司及其关联公司、控制公司向任何第三方赔偿或遭受国家机关处罚的，用户还应足额赔偿公司及其关联公司、控制公司因此遭受的全部损失。',
      ]
    },
    {
      title: '八、争议解决',
      content: [
        '1、本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国法律。倘若本协议之任何规定因与中华人民共和国法律抵触而无效，则这些条款应在不违反法律的前提下按照尽可能接近本协议原条文目的之原则进行重新解释和适用，且本协议其它规定仍应具有完整的效力及效果。',
        '2、本协议的签署地点为中华人民共和国北京市朝阳区，若用户与公司发生任何争议，双方应尽量友好协商解决，协商不成，用户同意应将争议提交至北京市朝阳区人民法院诉讼解决。',
      ]
    },
    {
      title: '九、其他',
      content: [
        '1、本网站的服务具体内容根据实际情况提供，本网站保留变更、中断或终止部分或全部服务的权利。本网站不承担因业务调整给用户造成的损失。除非本协议另有其它明示规定，增加或强化目前本网站的任何新功能，包括所推出的新产品，均受到本协议之规范。用户了解并同意，本网站服务仅依其当前所呈现的状况提供，对于任何用户通讯或个人化设定之时效、删除、传递错误、未予储存或其它任何问题，本网站均不承担任何责任。',
        '2、本网站平台有权根据法律、国家有权机构或公司经营需求修改本协议的有关条款，本网站将会通过适当方式在网站上予以公示。如果用户不同意本网站对本协议相关条款所做的修改，用户有权停止使用本网站服务。如果用户继续使用本网站服务，则视为用户接受本网站对本协议相关条款所做的修改。如果你对本网站提供服务有任何问题、疑虑或建议，可通过以下方式与我们联系，',
        '联系方式如下: 邮箱：Aden@yadingdata.com',
      ]
    }
  ]
}

export const secret: AgreementData = {
  introduce: "本网站深知个人信息对您的重要性，我们将按照法律法规的规定，会尽力保护您的网络个人隐私安全。本隐私政策将向您说明，我们如何收集、保存、使用、共享、保护您的个人信息。请您在使用我们提供的服务前，仔细阅读本隐私政策，在充分了解并同意后，使用我们提供的服务。如果您/您的监护人不同意本隐私政策的任何内容，请立刻停止使用我们的服务。",
  content: [
    {
      title: '本隐私政策主要包含以下内容：',
      content: [
        '1. 本隐私政策的适用范围；',
        '2. 个人信息的定义与范围；',
        '3. 我们如何收集您的个人信息；',
        '4. 我们如何使用Cookie和同类技术；',
        '5. 个人信息的安全的保护；',
        '6. 个人信息的使用规则；',
        '7. 个人信息的共享、公开披露；',
        '8. 您如何管理您的个人信息；',
        '9. 如何保护未成年人的个人信息；',
        '10. 隐私政策更新；',
        '11. 如何联系我们。'
      ]
    },
    {
      title: '1. 本隐私政策的适用范围',
      content: [
        '本隐私政策适用于本网站向您提供的所有服务，您使用本网站提供的服务时，均适用本隐私政策。'
      ]
    }, {
      title: '2. 个人信息的定义与范围',
      content: [
        '2.1 个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人个人身份或者反映特定自然人活动情况的各种信息。',
        '2.2 个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。',
        '2.3 匿名化处理后的信息：通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后不能被复原的信息，匿名化处理后的信息不属于个人信息。',
        '2.4 其他无法识别特定自然人身份或者反映特定自然人活动情况的信息不属于个人信息。'
      ]
    },
    {
      title: '3. 个人信息的收集方式',
      content: [
        '3.1 我们仅会出于本隐私政策所述的以下目的，收集您的个人信息：为了遵守法律法规的要求，向您提供更好以及更个性化的服务，并努力提高您的用户体验。',
        '3.2 您需要向我们提供您的身份信息（姓名、通讯地址、电子邮件地址、电话号码等），并设置您的密码，以完成注册及相关信息验证。这些信息属于个人敏感信息，您可以拒绝提供，如果拒绝提供您将可能无法获得相关服务。当您注册我们的账户及您在使用我们提供的相关服务时，我们以此识别您在平台的身份，并为您提供服务。',
        '3.3 基于网站使用方式，为保障推荐内容的质量并向您推荐可能感兴趣的视频及相关信息，网站可能会收集您相关必要的日志信息。上述日志信息包括，但不仅限于：（1）您操作、使用的行为信息：点击、关注、收藏、搜索、浏览、分享；（2）您主动提供的信息：反馈、发布、点赞（喜欢）、评论；（3）地理位置信息：GPS信息、WLAN接入点、蓝牙和基站等传感器信息等。',
      ]
    },
    {
      title: '4. 我们如何使用Cookie及同类技术',
      content: [
        '4.1 Cookie是支持服务器端（或者脚本）在客户端上存储和检索信息的一种机制。当您使用我们的产品或服务时，为使您获得更轻松安全的访问体验，我们可能会使用Cookie或同类技术来收集和存储信息，在此过程中可能会向您的设备发送一个或多个 Cookie 或匿名标识符。这么做是为了收取您的信息，用于了解您的偏好，进行咨询或数据分析，改善产品服务及用户体验，或及时发现并防范安全风险，为您提供更好的服务。我们不会将Cookie用于本政策所述目的之外的任何用途，您可根据自己的偏好留存或删除Cookie。您可清除软件内保存的所有Cookie，当您手动清除后您的相关信息即已删除。'
      ]
    },
    {
      title:'5.个人信息的安全的保护',
      content:[
        '5.1 我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或在未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。我们仅在为提供本网站服务之目的所必需的期间内保留您的个人信息：您发布的信息、评论、喜欢（点赞）及相关信息，在您未注销帐号期间，我们会保留相关信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。',
        '5.2 我们会使用不低于行业同行的加密技术、匿名化处理及相关合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。',
        '5.3 我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。',
        '5.4 尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。',
        '5.5 您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的帐号密码及相关个人信息透露给他人等。',
        '5.6 我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止这些安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以推送通知、邮件、信函、短信及相关形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。',
        '5.7 您一旦离开本网站，浏览或使用其他网站、服务及内容资源，我们将没有能力和直接义务保护您在本网站之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于本网站的链接或引导。'
      ]
    },
    {
      title:'6. 个人信息的使用规则',
      content:[
        '6.1 使用个人信息，以向您提供各项服务，并维护、改进这些服务。',
        '6.2 我们可能会将来自某项服务的个人信息与来自其他项服务所获得的个人信息结合起来，进行综合统计、分析或加工等处理，为您提供更加个性化、便捷的服务。',
        '6.3 我们可能以用户个人信息统计数据为基础设计、开发、推广全新的服务，或与公众或第三方分享这些统计信息，但这些统计信息不包含您的任何身份识别信息。',
        '6.4 请您知悉，以下情形中，我们可能会收集、使用您的相关个人信息而无需征求您的授权同意：',
        '  a. 与国家安全、国防安全直接相关的；',
        '  b. 与公共安全、公共卫生、重大公共利益直接相关的；',
        '  c. 与犯罪侦查、起诉、审判和判决执行等直接相关的；',
        '  d. 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；',
        '  e. 所收集的个人信息是个人信息主体自行向社会公众公开的；',
        '  f. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；'
      ]
    },
    {
      title:'7. 个人信息的共享、公开披露',
      content:[
        '7.1 您可以共享、公开披露您的个人信息。',
        '7.1.1 您可以通过我们的服务建立联系和相互分享。当您在平台公开分享任何信息时，任何人都可能在使用平台服务时查看或访问这些信息，请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。',
        '7.2 我们将遵守相关法律法规，对您的个人信息予以保密。除以下情况外，我们不会将您的个人信息共享、转让、公开披露给第三方：',
        '7.2.1 获得您的同意或授权。',
        '7.2.2 根据法律法规的规定或行政、司法机构等有权机关的要求或者授权。',
        '7.2.3 出于实现“个人信息的使用规则”部分所述目的，或为履行我们在用户协议或本隐私政策中的义务和行使我们的权利，向第三方共享您的个人信息。',
        '7.2.4  某些情况下，只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议。',
        '7.3 根据相关法律法规及国家标准，以下情形中，我们可能会共享、公开披露个人信息无需事先征得个人信息主体的授权同意：',
        '  a. 与国家安全、国防安全直接相关的；',
        '  b. 与公共安全、公共卫生、重大公共利益直接相关的；',
        '  c. 与犯罪侦查、起诉、审判和判决执行等直接相关的；',
        '  d. 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；',
        '  e. 个人信息主体自行向社会公众公开的个人信息；',
        '  f. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。'
      ]
    },
    {
      title:'8. 您如何管理您的个人信息',
      content:[
        '您对您的个人信息享有以下权利：',
        '8.1 访问、更正您的个人信息；',
        '8.2 查询访问、更正、删除信息您的日志信息；',
        '8.3 注销账号；您可以通过网站平台注销您的账号。除法律法规另有规定外，注销账号之后我们将停止为您提供服务，并根据本协议约定期限保存您的个人信息，保存期限届满后我们将对您的个人信息进行匿名化处理。',
        '8.4 出于安全性和身份识别的考虑，您可能无法自主修改注册时提交的某些初始注册信息（如实名认证后信息）；如您确有必要修改该类信息，请您通过电话或电子邮件联系我们，我们将尽快审核所涉问题，并由专人验证您的用户身份后及时予以回复。',
      ]
    },
    {
      title:'9. 如何保护未成年人的个人信息',
      content:[
        '9.1 我们极其重视对未成年人信息的保护。我们的服务主要面向成年人，如果您是已满14周岁未满18周岁的未成年人，请您的监护人仔细阅读本政策，在得到您的监护人同意后使用我们的服务。如果您是未满14周岁的未成年人，您的监护人需要仔细阅读本政策并同意您使用我们的服务。',
        '9.2 如果您/您的监护人不同意本隐私政策的任何内容，请您立刻停止使用本平台服务。'
      ]
    },
    {
      title:'10. 隐私政策更新',
      content:[
        '本网站平台有权根据法律、国家有权机构或公司经营需求修改本协议的有关条款，本网站将会通过适当方式在网站上予以公示。如果用户不同意本网站对本协议相关条款所做的修改，用户有权停止使用本网站服务。如果用户继续使用本网站服务，则视为用户接受本网站对本协议相关条款所做的修改。如果你对本网站提供服务有任何问题、疑虑或建议，可通过以下方式与我们联系，',
        '联系方式如下：邮箱：Aden@yadingdata.com'
      ]
    }
  ]
}